// extracted by mini-css-extract-plugin
export default {"newLine":"Style_newLine__JQse7","title":"Style_title__BubcP"};